import { media } from '../../../theme/shared/breakpoints';
const handleContainerPadding = (noPadding = false) => {
    if (noPadding)
        return 'padding: 0;';
    return `
    padding: 0 16px;
    ${media.medium} {
        padding: 0 24px;
    }

    ${media.xLarge} {
        padding: 0 15px;
    }
  `;
};
export default handleContainerPadding;
//# sourceMappingURL=Container.helpers.js.map